import BillingAccountsApi from './BillingAccounts'
import CreditNotesApi from './CreditNotes'
import InvoicesApi from './Invoices'
import QuotesApi from './Quotes'

export default {
    billingAccounts: BillingAccountsApi,
    creditNotes: CreditNotesApi,
    invoices: InvoicesApi,
    quotes: QuotesApi
}
